import React from 'react';
import { TextInput } from '@abyss/web/ui/TextInput';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { styled } from '@abyss/web/tools/styled';
import { formFormatterRegex } from '../../../resources/formFormatterRegex';

const StyledTextInput = styled(TextInput, {
  'input::-webkit-contacts-auto-fill-button': {
    visibility: 'hidden',
    display: 'none !important',
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
  },
});

export const LastName = () => {
  const { notAllowNumeric } = formFormatterRegex;
  const { modelPrefix, onBlur } = usePropsContext();

  return (
    <StyledTextInput
      width="50%"
      data-testid="lastname"
      label="Last name"
      subText="Add an asterisk (*) for a partial name search"
      descriptorsDisplay="column"
      model={`${modelPrefix}.lastName`}
      maxLength={50}
      validators={{
        required: 'Please enter a value',
        minLength: {
          value: 4,
          message: 'Please enter at least 4 alphanumeric characters',
        },
        validate: {
          wildCard: v =>
            v.includes('*') && !v.endsWith('*')
              ? 'Wild card must be at the end of the last name'
              : true,
          wildCardLength: v =>
            v.includes('*') && v.length < 5
              ? 'A minimum of 4 alphanumeric character(s) is required for last name when using a wild card'
              : true,
        },
      }}
      formatter={value => {
        return value.replace(notAllowNumeric, '');
      }}
      onBlur={() => onBlur(`${modelPrefix}.lastName`)}
    />
  );
};
